import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Guarda de UI: solo SuperAdmin. Va dentro de ProtectedRoute (que ya valida
// sesión). La autorización real de datos sigue siendo del backend.
const SuperAdminRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user?.esSuperAdmin) return <Navigate to="/dashboard" replace />;
  return children;
};

export default SuperAdminRoute;
